import { Select } from "@/components/ui/select";
import { useLines } from "@/features/lines/hooks";
import type { OrgAttentionQuery } from "@/types/attention.types";

export type TypeFilter = OrgAttentionQuery["type"] | "";
export type SeverityFilter = NonNullable<OrgAttentionQuery["severity"]> | "";
export type FlappingFilter = "" | "true";

interface Props {
  lineId: string;
  type: TypeFilter;
  severity: SeverityFilter;
  flapping: FlappingFilter;
  onLineChange: (lineId: string) => void;
  onTypeChange: (type: TypeFilter) => void;
  onSeverityChange: (severity: SeverityFilter) => void;
  onFlappingChange: (flapping: FlappingFilter) => void;
}

export function AlarmsFilters({
  lineId,
  type,
  severity,
  flapping,
  onLineChange,
  onTypeChange,
  onSeverityChange,
  onFlappingChange,
}: Props) {
  const linesQuery = useLines();
  const { data: lines = [] } = linesQuery;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Select
        aria-label="Filtrar por linha"
        value={lineId}
        onChange={(e) => onLineChange(e.target.value)}
        className="h-9 w-auto min-w-[10rem] text-sm"
        // Filtro de baixo risco: em erro, degrada para "Todas as linhas" (sem opções
        // extras) em vez de bloquear a tela de alarmes por causa de um select secundário.
        disabled={linesQuery.isError}
      >
        <option value="">Todas as linhas</option>
        {lines.map((l) => (
          <option key={l.id} value={l.id}>
            {l.name}
          </option>
        ))}
      </Select>

      <Select
        aria-label="Filtrar por tipo"
        value={type ?? ""}
        onChange={(e) => onTypeChange((e.target.value || "") as TypeFilter)}
        className="h-9 w-auto min-w-[9rem] text-sm"
      >
        <option value="">Todos os tipos</option>
        <option value="ALARM">Alarme</option>
        <option value="STOP">Parada</option>
        <option value="NODATA">Sem dados</option>
      </Select>

      <Select
        aria-label="Filtrar por severidade"
        value={severity}
        onChange={(e) => onSeverityChange((e.target.value || "") as SeverityFilter)}
        className="h-9 w-auto min-w-[9rem] text-sm"
      >
        <option value="">Todas as severidades</option>
        <option value="HIGH">Alta</option>
        <option value="MEDIUM">Média</option>
        <option value="LOW">Baixa</option>
      </Select>

      <Select
        aria-label="Filtrar por oscilação"
        value={flapping}
        onChange={(e) => onFlappingChange((e.target.value || "") as FlappingFilter)}
        className="h-9 w-auto min-w-[9rem] text-sm"
      >
        <option value="">Estável e instável</option>
        <option value="true">Apenas oscilando</option>
      </Select>
    </div>
  );
}
